export default __webpack_public_path__ + "static/media/dansketext-semibold.30cbbd72.eot";